export default __webpack_public_path__ + "static/media/cycloneofsteel10.804855ba.png";